import { observable } from 'mobx';

// 独立公告页store
export class TaskDetialStore {
  @observable detailShow = false
}

export default new TaskDetialStore();
